const BACKEND_URL =
  "https://szuumq8b3e.execute-api.ap-south-1.amazonaws.com/prod";

export default BACKEND_URL;
